import { render, staticRenderFns } from "./banner-basic-b1.vue?vue&type=template&id=0be1586a&scoped=true&"
import script from "./banner-basic-b1.vue?vue&type=script&lang=js&"
export * from "./banner-basic-b1.vue?vue&type=script&lang=js&"
import style0 from "./banner-basic-b1.vue?vue&type=style&index=0&id=0be1586a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be1586a",
  null
  
)

export default component.exports